import {z} from 'zod';
import {validateZod, errors} from '@strapi/utils';
import {SERVICE} from "../../../../constants";

  const infoUser = validateZod(z.object({
    id: z.number().positive().nullish(),
    uid: z.string().nullish(),
    email: z.string().email().nullish(),
    service: z.enum(SERVICE).nullish()
  })
    .strict());

export function validateLinkInfo(data: any, isGet=false) {
  const {id, uid, email, address, signature, service, telegramId} = data;

  // Issue-66 || Validate service
  // Issue-66 || Validate id number => Should create utils method and validate with zod
  // Issue-66 || Validate uid string => Should create utils method and validate with zod
  // Issue-66 || Validate email address => Should create utils method and validate with zod
  const userInfo = {
    id,
    uid,
    email,
    service
  }

  infoUser(userInfo);

  if (isGet) {
    return;
  }

  // Issue-66 || Validate have at least one of email or id or address
  if (!id && !uid && !email && !address) {
    throw new errors.ValidationError('Need at least one of email or id or address');
  }
  // Issue-66 || Validate address evm / substrate => Should implement with service from blockchain plugin
  // Issue-66 || Validate signature if existed => Should implement with service from blockchain plugin

  const blockchainService = strapi.plugin('blockchain').service('validateSignature');
  const shouldValidateLinkingSignature = strapi.plugin('telegram-bot').config<boolean>('user.validateLinkingSignature');
  if(shouldValidateLinkingSignature) {
    if (address && signature && telegramId) {
      if (!blockchainService.validateSignature(address, telegramId, signature)) {
        throw new errors.ValidationError('Invalid signature');
      }
    }
  }
}


